import React from 'react'
import loading from '../assest/foodLanding.gif'

function Loader () {
    return (
        <div className="loader">
            <img style={{ width: "20%" }} src={loading} alt="" />
        </div>
    )
}

export default Loader
